module.exports = __webpack_public_path__ + "static/img/image_set_coconuts.6e6ad9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_set_coconuts.jpg
// module id = sYPl
// module chunks = 1